module.exports = __webpack_public_path__ + "media/images/muramed-9a5dec4e548257c997de6ad353addda2.png";